import startupModalTemplate from './startupModal.html';
import startupTemplate from './startup.html';

const startupModal = {

    bindings: {
        disable: '='
    },

    template: startupTemplate,

    controller: function ($scope, $state, $ionicModal, ApiUser, ApiDashboard) {
        this.modal = $ionicModal.fromTemplate(startupModalTemplate, {
            scope: $scope
        });
        this.step = 1;
        this.user = {};
        // this.startupVideoUrl = ''; // YouTube video url

        this.$onInit = function () {
            this.dontShowHelp = false;
            this.getUserHelpStatus();
            // Add the youtibe video url here
            this.startupVideoUrl = '';
            ApiDashboard.isStartupDisplayed = true;
        };

        this.openModal = () => {
            this.modal.show();
        };

        this.closeModal = () => {
            // Uncomment the following line of code
            // this.youtubePlayer.stopVideo();
            this.modal.hide();
        };

        this.getUserHelpStatus = () => {
            ApiUser.getUser().then((res) => {
                if (res) {
                    this.dontShowHelp = !res.showHelp;
                    this.user = res;
                } else {
                    this.dontShowHelp = false;
                }
            });
        }

        this.updateUserHelpStatus = () => {
            this.user.showHelp = !this.dontShowHelp;
            if (this.dontShowHelp) {
                ApiUser.deactivateStartupWizard();
            }
            this.closeModal();
        }
    }
};

export default startupModal;



/** WEBPACK FOOTER **
 ** ./src/app/directives/startupModal/startup.js
 **/